import { render, staticRenderFns } from "./StatsTitle.vue?vue&type=template&id=01ebe006&scoped=true&"
import script from "./StatsTitle.vue?vue&type=script&lang=js&"
export * from "./StatsTitle.vue?vue&type=script&lang=js&"
import style0 from "./StatsTitle.vue?vue&type=style&index=0&id=01ebe006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ebe006",
  null
  
)

export default component.exports